import { PageHeader } from "@/components/page-header";
import { PlaidConnectPanel } from "@/components/settings/plaid-connect-panel";

export function SettingsPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow="Workspace"
        title="Settings"
        description="Connect external accounts and manage workspace preferences."
      />
      <section className="space-y-3">
        <div>
          <h2 className="text-sm font-semibold text-foreground">
            Plaid integration
          </h2>
          <p className="text-sm text-muted-foreground">
            Link banks, credit cards, and brokerages so balances sync
            automatically. Sandbox connections are placeholders today — real
            data fetch lands in a follow-up issue.
          </p>
        </div>
        <PlaidConnectPanel />
      </section>
    </div>
  );
}
